import Vue from "vue";

Vue.mixin({
    methods: {
        setupOTPC(updateCodeCallback) {
            const input = document.getElementById("otpInput");
            if (!input) {
                return;
            }
            console.log(input)
            this.abortController = new AbortController();
            const form = input.closest("form");

            if (form) {
                form.addEventListener("submit", () => {
                    this.abortController.abort();
                });
            }

            navigator.credentials
                .get({
                    otp: { transport: ["sms"] },
                    signal: this.abortController.signal,
                })
                .then((otp) => {
                    if (otp && otp.code) {
                        updateCodeCallback(otp.code);
                    }
                })
                .catch((err) => {

                });
        },
    },
})